export enum UserRole {
  ADMIN = 'tca-admin',
  CLIENT_SERVICE = 'tca-client-service',
  PRODUCTION = 'tca-production',
  METHOD = 'tca-method',
  LOGISTIC = 'tca-logistic',
  QUALITY = 'tca-quality',
  USER = 'tca-user'
}

export enum UserRoleLabel {
  ADMIN = 'Administration',
  CLIENT_SERVICE = 'Service client',
  PRODUCTION = 'Production',
  METHOD = 'Méthode',
  LOGISTIC = 'Logistique',
  QUALITY = 'Qualité',
  USER = '',
}
